// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  article: (t, data?, options?) => t('enum.bibliography-type.article.name', data, options),
  book: (t, data?, options?) => t('enum.bibliography-type.book.name', data, options),
  /* eslint-enable max-len */
};
